import React from 'react';
import TourTable from '@/features/dashboard/tours/components/TourTable.tsx';

const ToursPage = () => {
  return <TourTable />;
};

export default ToursPage;
